const settingRouter = [
    {
        path: "setting",
        name: "setting",
        component: () => import("@/views/admin/setting/function"),
        default: true,
        meta: {
            model: "setting"
        },
    }
]
export default settingRouter;